import React, { useState } from 'react';
import { SectionHead, Icon } from './Primitives';
import './UnityAdaptive.css';
const variants = [
  {
    label: 'More support',
    title: 'Start with a familiar example.',
    text: 'A useful explanation connects a new idea to something you already know. Think of it as adding a new piece to a picture you recognise.',
    caption: 'A simpler explanation of the same concept.',
  },
  {
    label: 'Standard',
    title: 'Connect new ideas to prior knowledge.',
    text: 'Understanding develops when learners relate new information to an existing mental model. A relevant example helps establish that connection.',
    caption: 'The standard explanation of the concept.',
  },
  {
    label: 'More depth',
    title: 'Build stronger conceptual connections.',
    text: 'Prior knowledge provides a structure for integrating new information. Well-chosen examples expose relationships and support transfer to a different context.',
    caption: 'A more detailed explanation of the same concept.',
  },
];
export default function UnityAdaptive({ assetBase }) {
  const [level, setLevel] = useState(1);
  const v = variants[level];
  return (
    <section className="ul-section ul-adaptive" id="adapt">
      <div className="ul-container">
        <div className="ul-adaptive-grid">
          <div>
            <SectionHead
              eyebrow="03 / Support the next step"
              title={
                <>
                  The standard stays fixed.
                  <br />
                  <em>The explanation adapts.</em>
                </>
              }
            >
              Different learners need different explanations. Unity uses assessment results to
              select the next available level from your prepared content.
            </SectionHead>
            <div className="ul-adaptive-point">
              <Icon name="check" />
              <p>
                Keep the learning goal consistent.
                <br />
                <strong>Offer more support or more challenge.</strong>
              </p>
            </div>
            <p className="ul-note">
              Available in Deliver and Impact. Adaptation uses prepared lesson levels; it does not
              create a new lesson for every interaction.
            </p>
          </div>
          <div className="ul-adaptive-demo">
            <div className="ul-adaptive-demo-label">
              <Icon name="spark" size={16} /> One concept. Different explanations.
            </div>
            <div className="ul-level-options" aria-label="Example explanation complexity">
              {variants.map((v, i) => (
                <button
                  type="button"
                  key={v.label}
                  aria-pressed={level === i}
                  onClick={() => setLevel(i)}
                >
                  {v.label}
                </button>
              ))}
            </div>
            <article aria-live="polite">
              <span className="ul-tag">Making new ideas easier to understand</span>
              <h3>{v.title}</h3>
              <p>{v.text}</p>
              <div>
                <span>Same learning outcome</span>
                <Icon name="check" size={16} />
              </div>
            </article>
            <p className="ul-adaptive-caption">Illustrative explanations · {v.caption}</p>
          </div>
        </div>
        <div className="ul-extra-capabilities">
          <article>
            <Icon name="globe" size={24} />
            <div>
              <h3>Reach more learners.</h3>
              <p>Prepare supported native language editions, with review guidance for your team.</p>
            </div>
          </article>
          <article>
            <Icon name="spark" size={24} />
            <div>
              <h3>Give progress a moment.</h3>
              <p>Celebrate meaningful steps with badges. Add learning expeditions in Impact.</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
